// Premium in-app notifications. API-compatible with `import { toast } from "react-toastify"`.
//
//   import { toast } from ".../components/AppToast";
//   toast.success("Saved");
//   toast.error(err, { autoClose: 6000 });
//   toast.info("Exported", { title: "Report ready", action: { label: "Open", onClick } });

export { default as toast, toast as default, TYPE, POSITION, configure } from "./toast";
export { default as AppToastHost, default as ToastContainer } from "./AppToastHost";
